const routes = {
  root: '/certificate/details',
}

export default routes
